var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMymachineNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3550_166063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 16.8184V21.3516H1.14655V4.7609",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26691 0.640625H16.0349V5.17383",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26731 0.641446V4.76172H1.14661",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14679 4.7627L5.26728 0.642207",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.421 10.9975C17.421 11.7631 16.8004 12.3838 16.0348 12.3838C15.2692 12.3838 14.6486 11.7631 14.6486 10.9975C14.6486 10.2319 15.2692 9.61127 16.0348 9.61127C16.8004 9.61127 17.421 10.2319 17.421 10.9975Z",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8575 12.085V9.90722L19.9148 9.69174C19.854 9.51092 19.7808 9.33582 19.6965 9.1673L20.9146 7.63813L19.3713 6.1017L17.8476 7.32669C17.6841 7.24578 17.5145 7.17531 17.3396 7.11653L17.1241 5.17383H14.9463L14.7309 7.11653C14.55 7.17729 14.3749 7.25051 14.2064 7.33486L12.6773 6.11674L11.1408 7.66009L12.3658 9.18372C12.2849 9.34721 12.2144 9.51677 12.1557 9.69174L10.213 9.90722V12.085L12.1557 12.3005C12.2164 12.4813 12.2896 12.6564 12.374 12.8249L11.1558 14.3541L12.6992 15.8905L14.2228 14.6655C14.3863 14.7464 14.5559 14.8169 14.7309 14.8757L14.9463 16.8184H17.1241L17.3396 14.8757C17.5204 14.8149 17.6955 14.7417 17.8641 14.6573L19.3932 15.8755L20.9296 14.3321L19.7046 12.8085C19.7855 12.645 19.856 12.4754 19.9148 12.3005L21.8575 12.085Z",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72491 15.0752H7.63494",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72491 17.6533H9.78338",
    stroke: "#5E5E5E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3550_166063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMymachineNew);
export default __webpack_public_path__ + "static/media/mymachine-new.146aa6621a5a7110ac53208ba1673452.svg";
export { ForwardRef as ReactComponent };